import parse from 'html-react-parser'
import sanitizeHtml from 'sanitize-html'

import {twMerge} from '@sdox/utils'
import {IS_DEV} from '@sdox/utils/dom'

import styles from './richText.module.scss'
import {allowedTags, options} from './options'

import type {AllowedTags} from './options'
import type {PolymorphicProps} from '../../types'
import type {ElementType} from 'react'

export const richTextStyles = styles

export type RichTextProps<T extends ElementType> = PolymorphicProps<T> & {
  content: string
  allowedTags?: AllowedTags[]
}

const sanitize = (html: string, customAllowedTags?: AllowedTags[]) => {
  return sanitizeHtml(html, {
    allowedTags: (customAllowedTags ?? allowedTags) as string[],
    disallowedTagsMode: IS_DEV ? 'escape' : 'discard',
    allowedAttributes: {
      a: ['href', 'target', 'rel'],
      b: [],
      strong: [],
      i: [],
      em: [],
      span: [
        'data-footnote',
        'data-icon',
        'data-text-medium',
        'data-no-break',
        'data-paragraph',
      ],
    },
  })
}

export const RichText = <T extends ElementType = 'div',> (props: RichTextProps<T>) => {
  const {
    as,
    className,
    content,
    allowedTags,
    ...restProps
  } = props

  const Component = as || 'div'

  return (
    <Component
      className={twMerge(
        styles.typography,
        className,
      )}
      {...restProps}
    >
      {parse(sanitize(content, allowedTags), options)}
    </Component>
  )
}
